<iw-details-value
  label="withdrawal.bankTransferINR.name.label"
  [value]="details.name"
/>
<iw-details-value
  label="withdrawal.bankTransferINR.surname.label"
  [value]="details.surname"
/>
<iw-details-value
  label="withdrawal.bankTransferINR.accountNumber.label"
  [value]="details.accountNumber"
/>
<iw-details-value
  label="withdrawal.bankTransferINR.bankIfsc.label"
  [value]="details.bankIfsc"
/>
<iw-details-value
  label="withdrawal.bankTransferINR.bankName.label"
  [value]="details.bankName"
/>
<iw-details-value
  label="withdrawal.bankTransferINR.description.label"
  [value]="details.description"
/>
